import { useHasCameraDevice } from "./useHasCameraDevice";
import { useOS } from "./useOS";

/**
 * Returns true when the device both has a camera and runs a mobile OS
 * (iOS / Android) that honours the `capture="environment"` attribute
 * on file inputs. On desktop browsers the attribute is silently ignored,
 * so showing the camera button would be redundant with the file picker.
 */
export const useSupportsDeviceCapture = () => {
  const hasCameraDevice = useHasCameraDevice();
  const { isMobileOS } = useOS();

  return hasCameraDevice && isMobileOS();
};
